import React, { useEffect, useState } from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import QRCode from "qrcode";
import { useSVGOverlay } from "react-leaflet/SVGOverlay";

const styles = StyleSheet.create({
  page: { padding: 20, margin:'auto' },
  title: { fontSize: 15, marginRight:'auto',marginLeft:'auto', marginBottom: 0 },
  qr: { width: 100, height: 100, marginRight:'auto',marginLeft:'auto', marginBottom: 0, marginTop:0 },
  info: {fontSize:10,margin:'auto',backgroundColor:'#ff0000',textAlign:'center'},
  customer: {fontSize:9, color:'gray',margin:'auto'}
});

export default function PDFDocument({ data = "No Data", order_numbrer , date , client_name , phone = "", address = "", title = "Ticket" }) {
  const [qrDataUrl, setQrDataUrl] = React.useState("");
  const [order,setOrder] = useState({order_numbrer:order_numbrer,date:date,client:{name:client_name,phone:phone},address:address});
  console.log(date,address);
  React.useEffect(() => {
    QRCode.toDataURL(data, {errorCorrectionLevel: 'H'}).then(setQrDataUrl).catch((error)=>{console.log(error);});
  }, [data]);

  useEffect(()=>{
    setOrder({order_numbrer:order_numbrer,date:date,client:{name:client_name,phone:phone},address:address});
    console.log(date,order_numbrer,client_name,phone,address);
  },[date,order_numbrer,client_name,phone,address])

  return (
    <Document>
      <Page size="A4" style={{padding:30}}>
        <Text style={{fontSize:15,fontWeight:'bold',marginLeft:'auto',marginRight:'auto',marginBottom:10}}>{title} </Text>
        <Text style={{fontSize:10,marginLeft:'auto',marginRight:'auto',color:'gray'}}>Numéro de Commande : {order.order_numbrer}</Text>
        <Text style={{fontSize:10,marginLeft:'auto',marginRight:'auto',color:'gray'}}>Date : {order.date}</Text>
        <Text style={{fontSize:10,marginLeft:'auto',marginRight:'auto',color:'gray'}}>Client : {order.client.name}</Text>
        <Text style={{fontSize:10,marginLeft:'auto',marginRight:'auto',color:'gray'}}>Télephone : {order.client.phone}</Text>
        {!!order.address && <Text style={{fontSize:10,marginLeft:'auto',marginRight:'auto',color:'gray'}}>Addresse : {order.address}</Text>}
        {qrDataUrl && (<Image src={qrDataUrl} style={{width: 100, height: 100, marginRight:'auto',marginLeft:'auto', marginBottom: 10, marginTop:10}} />)}
        <Text style={{fontSize:6,marginLeft:'auto',marginRight:'auto',color:'gray'}}>Utiliser ce ticket pour confirmer votre commande, et conserver le car vous en aurez besoin à la livraison</Text>
      </Page>
    </Document>
  );
}